
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq_45T9T_RMiF16TGQA8RN40bJ_45uAbiaibP_gPW2a_CVtFgMeta } from "/src/pages/faq.vue?macro=true";
import { default as indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta } from "/src/pages/index.vue?macro=true";
import { default as searchdiefyeeZtAW1otWRt8RdalGiDJPPtnZrYzU5xl4FiwoMeta } from "/src/pages/search.vue?macro=true";
import { default as indexqkplWbRbh51653m1_45nO8nHvwUlIeVQMyFg0GAjaFUbMMeta } from "/src/pages/c/index.vue?macro=true";
import { default as contact_XjdSYBiCuSFsOBRXQNVwomgFJnK4lsCYpDrSQ7swzwMeta } from "/src/pages/contact.vue?macro=true";
import { default as fastcartZu69CCzNBLYTi10TbGF2oEuTuLcfWD1WK5Rid1eVEGsMeta } from "/src/pages/fastcart.vue?macro=true";
import { default as servicesK_45Dqkcn4FJ1d2iolDzoFyvws_45Lg_pmUfoUtEmtE4Vf8Meta } from "/src/pages/services.vue?macro=true";
import { default as loginKh1lzCxnBtobxkuv2GDj3oee1aTskBX3mKL0STWmGEcMeta } from "/src/pages/auth/login.vue?macro=true";
import { default as buyinglistUk_qmHY0wKw9juSHbso5whl7ETm4P6uzHSDcP_45yfiegMeta } from "/src/pages/buyinglist.vue?macro=true";
import { default as oci_45punchout7NqU_45BDH_VglnYrzH9Rsm58SVlgU5EX7GQo6_45Pu1M0wMeta } from "/src/pages/oci-punchout.vue?macro=true";
import { default as _91id_932YEsiSfulyg1Gs5_45_4550P7FAJCvB7tYXfnm9yGFTSLBwMeta } from "/src/pages/product/[id].vue?macro=true";
import { default as index410M0xsUjGIKHTjLJEuziKjLRvyDuzYXGIB9vDVQDbcMeta } from "/src/pages/quotes/index.vue?macro=true";
import { default as registerp__45WqYjweBSM9_45Ke3Et_KHOD3NRIZ0TmynBsXh8jze4Meta } from "/src/pages/auth/register.vue?macro=true";
import { default as quotesCCzWGY1vwtIlBGbXrgzwhcY4F4BOeGDE1rYC4ARmoigMeta } from "/src/pages/account/quotes.vue?macro=true";
import { default as _91_46_46_46categories_93AfzOHQoyPK_458CfuuCsmc8_45NfdBCdVnh0vNlu3AqhqHgMeta } from "/src/pages/[...categories].vue?macro=true";
import { default as validationdEWnWyRBspK8LxBAKyhhHoTd32i4YGu2wASdhDIGwG8Meta } from "/src/pages/auth/validation.vue?macro=true";
import { default as addresseskno9dR5Jj9LHEuubdSl_SJBqcXQEaEE9voVumbx_45FiMMeta } from "/src/pages/account/addresses.vue?macro=true";
import { default as _91_46_46_46categories_93bylW4R4wVEz9OmZgTIiAZcGvduFvDtGsfXocopUl4fcMeta } from "/src/pages/c/[...categories].vue?macro=true";
import { default as shippingFrMzxkOr3kNBCTjA45xbW_45Kf665NRAqkONmI5IwBD0IMeta } from "/src/pages/checkout/shipping.vue?macro=true";
import { default as _91id_930NOTnOVr264mSZUK1yHWAw7jl49WDMA_45uwE_jqlEUowMeta } from "/src/pages/checkout/cart/[id].vue?macro=true";
import { default as reset_45passwordgUEPokzjVolIeJSfbkYFVHxrrCI9r22vS4I0_45OIGWeMMeta } from "/src/pages/auth/reset-password.vue?macro=true";
import { default as index1DFJp9u7O8Av4W0CWeh7aM_45B5rr_AOXi9ECtpjkUP4AMeta } from "/src/pages/checkout/cart/index.vue?macro=true";
import { default as forgot_45passwordFpwAwxBggxx3KkxDmE50wQmdHR5V1iatb2SegeEJCN0Meta } from "/src/pages/auth/forgot-password.vue?macro=true";
import { default as customer_45accountPhJjgUiVPWB_45JOK0iuejHtsMKfSw_474u34Q_45rU8l7UMeta } from "/src/pages/account/customer-account.vue?macro=true";
import { default as user_45informationxUiN9EUWet5gsZQuK1tFRkt_45ajEZ2miXl0Csl8jLS88Meta } from "/src/pages/account/user-information.vue?macro=true";
import { default as order_45confirmationVwW7PElOOfra9SEhYTce_c9FASfxCuja7RuVkchaanQMeta } from "/src/pages/checkout/order-confirmation.vue?macro=true";
import { default as order_45confirmationB2q9xbSkKY9_hoqbUzvQQ_45pK1KZSNeGalku7K3Viq78Meta } from "/src/pages/quotes/checkout/order-confirmation.vue?macro=true";
export default [
  {
    name: "faq___fr-FR",
    path: "/faq",
    meta: faq_45T9T_RMiF16TGQA8RN40bJ_45uAbiaibP_gPW2a_CVtFgMeta || {},
    component: () => import("/src/pages/faq.vue")
  },
  {
    name: "faq___en-GB",
    path: "/en-GB/faq",
    meta: faq_45T9T_RMiF16TGQA8RN40bJ_45uAbiaibP_gPW2a_CVtFgMeta || {},
    component: () => import("/src/pages/faq.vue")
  },
  {
    name: "index___fr-FR",
    path: "/",
    meta: indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta || {},
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "index___en-GB",
    path: "/en-GB",
    meta: indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta || {},
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "search___fr-FR",
    path: "/search",
    meta: searchdiefyeeZtAW1otWRt8RdalGiDJPPtnZrYzU5xl4FiwoMeta || {},
    component: () => import("/src/pages/search.vue")
  },
  {
    name: "search___en-GB",
    path: "/en-GB/search",
    meta: searchdiefyeeZtAW1otWRt8RdalGiDJPPtnZrYzU5xl4FiwoMeta || {},
    component: () => import("/src/pages/search.vue")
  },
  {
    name: "c___fr-FR",
    path: "/c",
    meta: indexqkplWbRbh51653m1_45nO8nHvwUlIeVQMyFg0GAjaFUbMMeta || {},
    component: () => import("/src/pages/c/index.vue")
  },
  {
    name: "c___en-GB",
    path: "/en-GB/c",
    meta: indexqkplWbRbh51653m1_45nO8nHvwUlIeVQMyFg0GAjaFUbMMeta || {},
    component: () => import("/src/pages/c/index.vue")
  },
  {
    name: "contact___fr-FR",
    path: "/contact",
    meta: contact_XjdSYBiCuSFsOBRXQNVwomgFJnK4lsCYpDrSQ7swzwMeta || {},
    component: () => import("/src/pages/contact.vue")
  },
  {
    name: "contact___en-GB",
    path: "/en-GB/contact",
    meta: contact_XjdSYBiCuSFsOBRXQNVwomgFJnK4lsCYpDrSQ7swzwMeta || {},
    component: () => import("/src/pages/contact.vue")
  },
  {
    name: "fastcart___fr-FR",
    path: "/fastcart",
    meta: fastcartZu69CCzNBLYTi10TbGF2oEuTuLcfWD1WK5Rid1eVEGsMeta || {},
    component: () => import("/src/pages/fastcart.vue")
  },
  {
    name: "fastcart___en-GB",
    path: "/en-GB/fastcart",
    meta: fastcartZu69CCzNBLYTi10TbGF2oEuTuLcfWD1WK5Rid1eVEGsMeta || {},
    component: () => import("/src/pages/fastcart.vue")
  },
  {
    name: "services___fr-FR",
    path: "/services",
    meta: {"middleware":false},
    component: () => import("/src/pages/services.vue")
  },
  {
    name: "services___en-GB",
    path: "/en-GB/services",
    meta: {"middleware":false},
    component: () => import("/src/pages/services.vue")
  },
  {
    name: "auth-login___fr-FR",
    path: "/auth/login",
    meta: loginKh1lzCxnBtobxkuv2GDj3oee1aTskBX3mKL0STWmGEcMeta || {},
    component: () => import("/src/pages/auth/login.vue")
  },
  {
    name: "auth-login___en-GB",
    path: "/en-GB/auth/login",
    meta: loginKh1lzCxnBtobxkuv2GDj3oee1aTskBX3mKL0STWmGEcMeta || {},
    component: () => import("/src/pages/auth/login.vue")
  },
  {
    name: "buyinglist___fr-FR",
    path: "/buyinglist",
    meta: buyinglistUk_qmHY0wKw9juSHbso5whl7ETm4P6uzHSDcP_45yfiegMeta || {},
    component: () => import("/src/pages/buyinglist.vue")
  },
  {
    name: "buyinglist___en-GB",
    path: "/en-GB/buyinglist",
    meta: buyinglistUk_qmHY0wKw9juSHbso5whl7ETm4P6uzHSDcP_45yfiegMeta || {},
    component: () => import("/src/pages/buyinglist.vue")
  },
  {
    name: "oci-punchout___fr-FR",
    path: "/oci-punchout",
    meta: { ...(oci_45punchout7NqU_45BDH_VglnYrzH9Rsm58SVlgU5EX7GQo6_45Pu1M0wMeta || {}), ...{"middleware":"oci-punchout"} },
    component: () => import("/src/pages/oci-punchout.vue")
  },
  {
    name: "oci-punchout___en-GB",
    path: "/en-GB/oci-punchout",
    meta: { ...(oci_45punchout7NqU_45BDH_VglnYrzH9Rsm58SVlgU5EX7GQo6_45Pu1M0wMeta || {}), ...{"middleware":"oci-punchout"} },
    component: () => import("/src/pages/oci-punchout.vue")
  },
  {
    name: "product-id___fr-FR",
    path: "/product/:id()",
    meta: _91id_932YEsiSfulyg1Gs5_45_4550P7FAJCvB7tYXfnm9yGFTSLBwMeta || {},
    component: () => import("/src/pages/product/[id].vue")
  },
  {
    name: "product-id___en-GB",
    path: "/en-GB/product/:id()",
    meta: _91id_932YEsiSfulyg1Gs5_45_4550P7FAJCvB7tYXfnm9yGFTSLBwMeta || {},
    component: () => import("/src/pages/product/[id].vue")
  },
  {
    name: "quotes___fr-FR",
    path: "/quotes",
    meta: index410M0xsUjGIKHTjLJEuziKjLRvyDuzYXGIB9vDVQDbcMeta || {},
    component: () => import("/src/pages/quotes/index.vue")
  },
  {
    name: "quotes___en-GB",
    path: "/en-GB/quotes",
    meta: index410M0xsUjGIKHTjLJEuziKjLRvyDuzYXGIB9vDVQDbcMeta || {},
    component: () => import("/src/pages/quotes/index.vue")
  },
  {
    name: "auth-register___fr-FR",
    path: "/auth/register",
    meta: registerp__45WqYjweBSM9_45Ke3Et_KHOD3NRIZ0TmynBsXh8jze4Meta || {},
    component: () => import("/src/pages/auth/register.vue")
  },
  {
    name: "auth-register___en-GB",
    path: "/en-GB/auth/register",
    meta: registerp__45WqYjweBSM9_45Ke3Et_KHOD3NRIZ0TmynBsXh8jze4Meta || {},
    component: () => import("/src/pages/auth/register.vue")
  },
  {
    name: "account-quotes___fr-FR",
    path: "/account/quotes",
    meta: quotesCCzWGY1vwtIlBGbXrgzwhcY4F4BOeGDE1rYC4ARmoigMeta || {},
    component: () => import("/src/pages/account/quotes.vue")
  },
  {
    name: "account-quotes___en-GB",
    path: "/en-GB/account/quotes",
    meta: quotesCCzWGY1vwtIlBGbXrgzwhcY4F4BOeGDE1rYC4ARmoigMeta || {},
    component: () => import("/src/pages/account/quotes.vue")
  },
  {
    name: "categories___fr-FR",
    path: "/:categories(.*)*",
    meta: _91_46_46_46categories_93AfzOHQoyPK_458CfuuCsmc8_45NfdBCdVnh0vNlu3AqhqHgMeta || {},
    component: () => import("/src/pages/[...categories].vue")
  },
  {
    name: "categories___en-GB",
    path: "/en-GB/:categories(.*)*",
    meta: _91_46_46_46categories_93AfzOHQoyPK_458CfuuCsmc8_45NfdBCdVnh0vNlu3AqhqHgMeta || {},
    component: () => import("/src/pages/[...categories].vue")
  },
  {
    name: "auth-validation___fr-FR",
    path: "/auth/validation",
    meta: validationdEWnWyRBspK8LxBAKyhhHoTd32i4YGu2wASdhDIGwG8Meta || {},
    component: () => import("/src/pages/auth/validation.vue")
  },
  {
    name: "auth-validation___en-GB",
    path: "/en-GB/auth/validation",
    meta: validationdEWnWyRBspK8LxBAKyhhHoTd32i4YGu2wASdhDIGwG8Meta || {},
    component: () => import("/src/pages/auth/validation.vue")
  },
  {
    name: "account-addresses___fr-FR",
    path: "/account/addresses",
    meta: addresseskno9dR5Jj9LHEuubdSl_SJBqcXQEaEE9voVumbx_45FiMMeta || {},
    component: () => import("/src/pages/account/addresses.vue")
  },
  {
    name: "account-addresses___en-GB",
    path: "/en-GB/account/addresses",
    meta: addresseskno9dR5Jj9LHEuubdSl_SJBqcXQEaEE9voVumbx_45FiMMeta || {},
    component: () => import("/src/pages/account/addresses.vue")
  },
  {
    name: "c-categories___fr-FR",
    path: "/c/:categories(.*)*",
    meta: _91_46_46_46categories_93bylW4R4wVEz9OmZgTIiAZcGvduFvDtGsfXocopUl4fcMeta || {},
    component: () => import("/src/pages/c/[...categories].vue")
  },
  {
    name: "c-categories___en-GB",
    path: "/en-GB/c/:categories(.*)*",
    meta: _91_46_46_46categories_93bylW4R4wVEz9OmZgTIiAZcGvduFvDtGsfXocopUl4fcMeta || {},
    component: () => import("/src/pages/c/[...categories].vue")
  },
  {
    name: "checkout-shipping___fr-FR",
    path: "/checkout/shipping",
    meta: { ...(shippingFrMzxkOr3kNBCTjA45xbW_45Kf665NRAqkONmI5IwBD0IMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/src/pages/checkout/shipping.vue")
  },
  {
    name: "checkout-shipping___en-GB",
    path: "/en-GB/checkout/shipping",
    meta: { ...(shippingFrMzxkOr3kNBCTjA45xbW_45Kf665NRAqkONmI5IwBD0IMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/src/pages/checkout/shipping.vue")
  },
  {
    name: "checkout-cart-id___fr-FR",
    path: "/checkout/cart/:id()",
    meta: _91id_930NOTnOVr264mSZUK1yHWAw7jl49WDMA_45uwE_jqlEUowMeta || {},
    component: () => import("/src/pages/checkout/cart/[id].vue")
  },
  {
    name: "checkout-cart-id___en-GB",
    path: "/en-GB/checkout/cart/:id()",
    meta: _91id_930NOTnOVr264mSZUK1yHWAw7jl49WDMA_45uwE_jqlEUowMeta || {},
    component: () => import("/src/pages/checkout/cart/[id].vue")
  },
  {
    name: "auth-reset-password___fr-FR",
    path: "/auth/reset-password",
    meta: reset_45passwordgUEPokzjVolIeJSfbkYFVHxrrCI9r22vS4I0_45OIGWeMMeta || {},
    component: () => import("/src/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___en-GB",
    path: "/en-GB/auth/reset-password",
    meta: reset_45passwordgUEPokzjVolIeJSfbkYFVHxrrCI9r22vS4I0_45OIGWeMMeta || {},
    component: () => import("/src/pages/auth/reset-password.vue")
  },
  {
    name: "checkout-cart___fr-FR",
    path: "/checkout/cart",
    meta: { ...(index1DFJp9u7O8Av4W0CWeh7aM_45B5rr_AOXi9ECtpjkUP4AMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/src/pages/checkout/cart/index.vue")
  },
  {
    name: "checkout-cart___en-GB",
    path: "/en-GB/checkout/cart",
    meta: { ...(index1DFJp9u7O8Av4W0CWeh7aM_45B5rr_AOXi9ECtpjkUP4AMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/src/pages/checkout/cart/index.vue")
  },
  {
    name: "auth-forgot-password___fr-FR",
    path: "/auth/forgot-password",
    meta: forgot_45passwordFpwAwxBggxx3KkxDmE50wQmdHR5V1iatb2SegeEJCN0Meta || {},
    component: () => import("/src/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forgot-password___en-GB",
    path: "/en-GB/auth/forgot-password",
    meta: forgot_45passwordFpwAwxBggxx3KkxDmE50wQmdHR5V1iatb2SegeEJCN0Meta || {},
    component: () => import("/src/pages/auth/forgot-password.vue")
  },
  {
    name: "account-customer-account___fr-FR",
    path: "/account/customer-account",
    meta: customer_45accountPhJjgUiVPWB_45JOK0iuejHtsMKfSw_474u34Q_45rU8l7UMeta || {},
    component: () => import("/src/pages/account/customer-account.vue")
  },
  {
    name: "account-customer-account___en-GB",
    path: "/en-GB/account/customer-account",
    meta: customer_45accountPhJjgUiVPWB_45JOK0iuejHtsMKfSw_474u34Q_45rU8l7UMeta || {},
    component: () => import("/src/pages/account/customer-account.vue")
  },
  {
    name: "account-user-information___fr-FR",
    path: "/account/user-information",
    meta: user_45informationxUiN9EUWet5gsZQuK1tFRkt_45ajEZ2miXl0Csl8jLS88Meta || {},
    component: () => import("/src/pages/account/user-information.vue")
  },
  {
    name: "account-user-information___en-GB",
    path: "/en-GB/account/user-information",
    meta: user_45informationxUiN9EUWet5gsZQuK1tFRkt_45ajEZ2miXl0Csl8jLS88Meta || {},
    component: () => import("/src/pages/account/user-information.vue")
  },
  {
    name: "checkout-order-confirmation___fr-FR",
    path: "/checkout/order-confirmation",
    meta: { ...(order_45confirmationVwW7PElOOfra9SEhYTce_c9FASfxCuja7RuVkchaanQMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/src/pages/checkout/order-confirmation.vue")
  },
  {
    name: "checkout-order-confirmation___en-GB",
    path: "/en-GB/checkout/order-confirmation",
    meta: { ...(order_45confirmationVwW7PElOOfra9SEhYTce_c9FASfxCuja7RuVkchaanQMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/src/pages/checkout/order-confirmation.vue")
  },
  {
    name: "quotes-checkout-order-confirmation___fr-FR",
    path: "/quotes/checkout/order-confirmation",
    meta: { ...(order_45confirmationB2q9xbSkKY9_hoqbUzvQQ_45pK1KZSNeGalku7K3Viq78Meta || {}), ...{"middleware":"checkout"} },
    component: () => import("/src/pages/quotes/checkout/order-confirmation.vue")
  },
  {
    name: "quotes-checkout-order-confirmation___en-GB",
    path: "/en-GB/quotes/checkout/order-confirmation",
    meta: { ...(order_45confirmationB2q9xbSkKY9_hoqbUzvQQ_45pK1KZSNeGalku7K3Viq78Meta || {}), ...{"middleware":"checkout"} },
    component: () => import("/src/pages/quotes/checkout/order-confirmation.vue")
  }
]